import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import { Upload } from "react-bootstrap-icons";

const Brand = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [fileName, setFileName] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };
  return (
    <div className="profile" style={{ border: "1px solid black" }}>
      <div>
        <h2 className="text-center" style={{ color: "#5b807b" }}>
          Brand Profile
        </h2>
      </div>

      <Form>
        <div style={{ display: "flex", justifyContent: "space-evenly" }}>
          <div>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>User Name</Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                {/* <Form.Group className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" style={{ backgroundColor: '#c5c7c9' }} />
                                </Form.Group> */}
                <Form.Group controlId="formPassword">
                  <Form.Label>Password</Form.Label>
                  <InputGroup
                    style={{ backgroundColor: "#c5e0df", border: "none" }}
                  >
                    <Form.Control
                      type={showPassword ? "password" : "text"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <InputGroup.Text
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        cursor: "pointer",
                        background: "transparent",
                        border: "none",
                      }}
                    >
                      {showPassword ? <EyeSlashFill /> : <EyeFill />}
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Brand Name</Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>GST No</Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email ID</Form.Label>
                  <Form.Control
                    type="email"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Country City</Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                {/* <Form.Group className="mb-3">
                                    <Form.Label>Upload Logo</Form.Label>
                                    <Form.Control style={{ backgroundColor: '#c5c7c9' ,paddingTop:'80px' }} type="file" />
                                </Form.Group> */}
                <Form.Group controlId="formFileUpload">
                  <Form.Label>Upload Logo</Form.Label>
                  <InputGroup
                    className="p-2"
                    style={{ background: "#d3d3d3", borderRadius: "5px" }}
                  >
                    <label
                      htmlFor="fileInput"
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Upload size={30} />
                    </label>
                    <Form.Control
                      type="file"
                      id="fileInput"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                  </InputGroup>
                  {fileName && <p className="mt-2 text-muted">{fileName}</p>}
                </Form.Group>
              </Col>
            </Row>
          </div>

          <div style={{ marginTop: "250px", marginRight: "50px" }}>
            <h4 className="mt-3" style={{ color: "#5b807b" }}>
              All Social Media Links
            </h4>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>
                    Facebook <i className="fab fa-facebook"></i>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Instagram <i className="fab fa-instagram"></i>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Twitter <i className="fab fa-twitter"></i>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    LinkedIn <i className="fab fa-linkedin"></i>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    WhatsApp <i className="fab fa-whatsapp"></i>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Web Link<i className="fab fa-link"></i>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ backgroundColor: "#c5c7c9" }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
        </div>

        <div align="center">
          <Button
            type="submit"
            style={{
              borderRadius: "50px",
              color: "white",
              backgroundColor: "#628573",
              border: "1px solid #628573",
              padding: "10px 30px",
            }}
          >
            <Link
              to="/admin-dashboard"
              style={{ textDecoration: "none", color: "white" }}
            >
              SUBMIT
            </Link>
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Brand;
